<script setup lang="ts">
import type { MysteryBoxItem } from '@/types/mystery-box'
import { type EcommerceItem, MYSTERY_BOX_TYPE } from '@/types/shared/player-config'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import { computed, ref } from 'vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useEcommerceItemDetailsPurchase } from '@/composables/game/ecommerce'
import { useShop } from '@/composables/game/shop'

const props = defineProps<{
  show: boolean
  item: { box: MysteryBoxItem, ecommerceItem: EcommerceItem } | null
}>()
defineEmits<{
  (e: 'hide'): void
  (e: 'open', boxType: MYSTERY_BOX_TYPE): void
}>()

const   { canHaveSale,
} = props.item?.ecommerceItem ? useEcommerceItemDetailsPurchase(props.item?.ecommerceItem) : { canHaveSale: ref(false) }

const { isBOGO } = useShop()

const hasBOGO = computed(() => canHaveSale.value && isBOGO.value)

const itemMultiplier = computed(() => {
  if (!props.item?.ecommerceItem) return 1
  if (props.item.ecommerceItem.id.endsWith('X1')) return 1
  if (props.item.ecommerceItem.id.endsWith('X3')) return 3
  if (props.item.ecommerceItem.id.endsWith('X5')) return 5
  return 1
})
</script>

<template>
  <TheBottomSheet
    :show="show && !!item"
    content-class="p-0 px-6 pb-8"
    @hide="$emit('hide')"
  >
    <div
      v-if="item"
      class="flex-1 flex flex-col items-center"
    >
      <img
        class="size-[160px] object-cover"
        :src="item.box.image"
      >
      <div class="mt-3 text-center text-light-white text-2xl font-bold -tracking-[0.48px]">
        <T
          key-name="shop.success.title"
          default-value="Purchase successful!"
        />
      </div>
      <div class="text-center text-white/60 text-base font-medium">
        {{ item.box.name }} {{ " " }} x{{ itemMultiplier * (hasBOGO ? 2 : 1) }}
      </div>
      <div class="w-full mt-12 flex flex-col gap-y-3">
        <BaseButton
          class="w-full  scale-up-light"
          @click="$emit('open', item.box.boxType)"
        >
          <template #leftIcon>
            <img
              class="h-full w-auto object-cover"
              src="@/assets/images/emojis/emoji-box.png"
            >
          </template>
          <T
            key-name="mystery_box.success.open_your_box_now"
            default-value="Open your box now"
          />
        </BaseButton>
        <BaseButton
          style-type="secondary"
          class="w-full"
          @click="$emit('hide')"
        >
          <T
            key-name="mystery_box.success.save_for_later"
            default-value="Save for later"
          />
        </BaseButton>
      </div>
    </div>
  </TheBottomSheet>
</template>

<style scoped lang="scss">
@import "@/assets/styles/ecommerce";
</style>